module.exports = require("./ar-SO");